import { useSyncExternalStore } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '../components/Button'
import { imaNovoIzdanje, pretplatiIzdanje } from './izdanje'

/**
 * Traka "objavljena je nova verzija" (CLAUDE.md §13).
 *
 * Stoji iznad svih triju sučelja, jer se izdanje mijenja svima u istom trenutku.
 * Ne nudi "poslije": stari radnik je već zamijenjen, pa je odgoda samo odgoda —
 * traka ostaje dok korisnik ne osvježi ili dok kartica ne ode u pozadinu (tada se
 * osvježi sama, `izdanje.ts`).
 *
 * To zadnje je od dotjerivanja-3 §8 i STVARNO tako: dotad je rečenica stajala u
 * dokumentaciji, a mehanike nije bilo — traka koju nitko ne tapne ostajala je
 * stajati nad stranicom koja radi na buildu kojeg na disku više nema.
 */
export function NovoIzdanje() {
  const { t } = useTranslation()
  const dostupno = useSyncExternalStore(pretplatiIzdanje, imaNovoIzdanje, imaNovoIzdanje)

  if (!dostupno) return null

  return (
    <div
      role="status"
      className="fixed inset-x-0 bottom-0 z-50 px-4 pt-4"
      /* Traka geste na iPhoneu: poruka prikovana na `bottom-0` inače sjedne na nju. */
      style={{ paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 16px)' }}
    >
      <div className="mx-auto flex w-full max-w-sm items-center gap-3 rounded-2xl border border-brass bg-surface p-4 shadow-lg">
        <div className="flex-1">
          <p className="text-sm text-ivory">{t('pwa.update.title')}</p>
          <p className="mt-0.5 text-xs text-stone">{t('pwa.update.body')}</p>
        </div>
        <Button izgled="gold" onClick={() => globalThis.location.reload()}>
          {t('common.refresh')}
        </Button>
      </div>
    </div>
  )
}
